var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['fish switch', {'disabled': _vm.disabled}, {'checked': _vm.yesOrNo[0] === this.value}],on:{"click":_vm.clickHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }